import { useState, useEffect, FunctionComponent } from "react";
import { FiMenu } from "react-icons/fi";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Badge, Breadcrumbs, Modal, TextField, Theme, Typography, useTheme } from "@mui/material";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import logo from "../../Assests/in5.png";
import { makeStyles } from "@mui/styles";
import { FiSearch } from "react-icons/fi";
import { IoNotificationsOutline } from "react-icons/io5";
import { IoCalendarClearOutline } from "react-icons/io5";
import { HiOutlineShoppingCart } from "react-icons/hi2";
import { IonHeader, IonTitle, IonToolbar } from "@ionic/react";
import { PiArrowLeftBold } from "react-icons/pi";
import routes from "../../utils/routes.json";
import guest from "../../Assests/Guest.png";
import { userDispatch } from "../../utils/localStorage";
import { useSearchContext } from "../../contexts/SearchContextProvider";
import { getFirstLetters, shrinkTextBased } from "../../utils/helpers";
import Notifications from "../../pages/Notifications";

const useStyles = makeStyles((theme: Theme) => ({
  input: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#8C8E94",
    height: "32px",
    borderRadius: "20px !important",
  },
  mobileMenuLogo: {
    height: "32px",
    width: "32px",
    border: "2px solid #604797",
    borderRadius: "20px",
    padding: "12px",
  },
  dialog: {
    position: "absolute",
    left: 10,
    top: 50,
  },
  notificationContainer: {
    width: "450px",
    position: "absolute",
    right: "8%",
    top: "12%",
    height: "550px",
    borderRadius: "8px",
    overflow: "auto",
    background: "#fff",
  },
}));

const Header: FunctionComponent<any> = ({ handleSideBar, headerVariant, mobileHeaderVariant, breadCrumbs, handleMobileDrawer, cartCount }) => {
  const navigate = useHistory();
  const classes = useStyles();
  const themes = useTheme();
  const isMobileScreen: boolean = useMediaQuery(themes.breakpoints.down("md"));
  const location = useLocation();
  const { pathname, state, search }: any = location;
  const { data, dispatchData } = useSearchContext();
  const searchParams = new URLSearchParams(search);

  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const [user, setUser] = useState<any>();
  const [role, setRole] = useState<any>();
  const [open, setOpen] = useState<boolean>(false);

  const handleToggleDialog = () => {
    setOpen(!open);
  };

  useEffect(() => {
    const handleScroll: () => void = () => {
      const position = window.pageYOffset;
      if (position > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    userDispatch({ case: "GET", key: "user" })
      ?.then((res: any) => {
        setUser(typeof res === "string" ? JSON.parse(res) : res);
      })
      .catch((err: any) => {
        console.error(err);
      });

    userDispatch({ case: "GET", key: "role" })
      ?.then((res: any) => {
        setRole(res);
      })
      .catch((err: any) => {
        console.error(err);
      });
  }, []);

  let pageTitle = "";
  const tabTitle = pathname.split("/");
  if (tabTitle.length > 0) {
    pageTitle = tabTitle[tabTitle.length - 1];
  }
  const header = mobileHeaderVariant === "variant1";

  return (
    <>
      <Modal
        onClose={() => {
          handleToggleDialog();
        }}
        open={open}
        slotProps={{
          backdrop: {
            style: {
              opacity: 0.5,
            },
          },
        }}
      >
        <Box component={"div"} className={classes.notificationContainer}>
          <Notifications />
        </Box>
      </Modal>
      {isMobileScreen ? (
        <IonHeader collapse="fade">
          <IonToolbar style={{ width: "100%", borderBottom: "0.5px solid #F0EDF6" }}>
            <Box
              component={"div"}
              style={{
                padding: "16px 16px 12px 16px",
                background: "#fff",
                width: "100%",
              }}
            >
              <Box component={"div"} className="d-flex flex-nowrap justify-content-between align-items-center" gap={"10px"}>
                {header ? (
                  <IconButton
                    onClick={() => {
                      navigate.goBack();
                    }}
                  >
                    <PiArrowLeftBold
                      style={{
                        height: "20px",
                        width: "20px",
                        color: "#545454",
                      }}
                    />
                  </IconButton>
                ) : (
                  <Box
                    component={"div"}
                    className={`${classes.mobileMenuLogo} d-flex flex-column align-items-center justify-content-center`}
                    onClick={() => {
                      handleMobileDrawer();
                    }}
                  >
                    <Box component={"img"} src={logo} height={"18px"} width={"10px"} />
                  </Box>
                )}
                {header && (
                  <IonTitle>
                    {/* Hide title above breadcrumbs for all offerings on mobile */}
                    {!pathname.includes('/facility') && !pathname.includes('/book') && !pathname.includes('/meeting') && (
                      <Typography component={"h6"} variant="medium" textTransform={"capitalize"} textAlign={"center"} color={"#333333"}>
                        {shrinkTextBased(20, state?.breadcrumbs ? state?.breadcrumbs : pageTitle)}
                      </Typography>
                    )}
                  </IonTitle>
                )}
                {!header && (
                  <TextField
                    fullWidth
                    placeholder="Search"
                    value={data?.search}
                    onChange={(e) => {
                      dispatchData({
                        case: "ADD",
                        payload: {
                          key: "search",
                          data: e.target.value,
                        },
                      });
                    }}
                    InputProps={{
                      className: classes.input,
                      style: {
                        border: "0.5px solid #E9E9ED",
                        borderRadius: "50px",
                      },
                      startAdornment: <FiSearch fontSize={"20px"} />,
                    }}
                  />
                )}
                {/* {!header && pageTitle !== "notifications" && (
                  <IconButton
                    onClick={() => {
                      navigate.push(routes.notifications);
                    }}
                  >
                    <IoNotificationsOutline
                      style={{
                        height: "16px",
                        width: "auto",
                        color: "#604797",
                      }}
                    />
                  </IconButton>
                )} */}
                {pageTitle !== "calendar" && role && (
                  <IconButton
                    style={{ background: "#F0EDF6" }}
                    onClick={() => {
                      navigate.push(routes.calendar);
                    }}
                  >
                    <IoCalendarClearOutline
                      style={{
                        height: "16px",
                        width: "16px",
                        color: "#604797",
                      }}
                    />
                  </IconButton>
                )}
              </Box>
            </Box>
          </IonToolbar>
        </IonHeader>
      ) : (
        <AppBar position="static" sx={{ boxShadow: "none" }} className={`${isScrolled ? "bg-white" : "bg-transparent"}`}>
          <Toolbar
            component={"div"}
            className={(() => {
              // Check if there's a title/breadcrumb content on the left
              const hasLeftContent = headerVariant === "variant1" 
                ? !(pathname.includes('/facility') || pathname.includes('/book') || pathname.includes('/meeting'))
                : (!pathname.includes('/facility') && !pathname.includes('/book') && !pathname.includes('/meeting'));
              
              // Special case for facility routes - use space-between
              if (pathname.includes('/facility')) {
                return "justify-content-between align-items-center";
              }
              
              return hasLeftContent ? "justify-content-between align-items-center" : "justify-content-end align-items-center";
            })()}
            sx={{
              zIndex: "1",
              borderBottom: "2px solid #F0EDF6",
              padding: "20px 0px !important",
              margin: "10px 32px 0px 32px",
            }}
          >
            {isMobileScreen && (
              <IconButton onClick={handleSideBar}>
                <FiMenu />
              </IconButton>
            )}
            {headerVariant === "variant1" ? (
              // Hide title above breadcrumbs for all offerings - check if this is a facility/offering page
              pathname.includes('/facility') || pathname.includes('/book') || pathname.includes('/meeting') ? null : (
                <Typography component={"h6"} variant="largebold" textTransform={"capitalize"} color={"#333333"}>
                  {state?.breadcrumbs ? state?.breadcrumbs : searchParams.get("category") ? searchParams.get("category") : pageTitle}
                </Typography>
              )
            ) : (
              <Box component={"div"} className="d-flex flex-column" gap={"10px"}>
                {/* Hide title above breadcrumbs for all offerings - check if this is a facility/offering page */}
                {!pathname.includes('/facility') && !pathname.includes('/book') && !pathname.includes('/meeting') && (
                  <Typography component={"h6"} variant="largebold" textTransform={"capitalize"} color={"#333333"}>
                    {state?.breadcrumbs ? state?.breadcrumbs : searchParams.get("category") ? searchParams.get("category") : pageTitle}
                  </Typography>
                )}
                <Breadcrumbs separator=">">
                  {(state?.breadCrumbItems || []).map((items: any, index: number) => {
                    const isLastIndex = index === (breadCrumbs ? breadCrumbs : state?.breadCrumbItems).length - 1;
                    return (
                      <Typography
                        component={"h6"}
                        onClick={() => {
                          navigate.goBack();
                        }}
                        sx={{
                          cursor: index === 0 ? "pointer" : "auto",
                          textTransform: "capitalize",
                        }}
                        variant={isLastIndex ? "smallmedium" : "smallthin"}
                        color={!isLastIndex ? "#333333" : "#4B3776"}
                      >
                        {items}
                      </Typography>
                    );
                  })}
                </Breadcrumbs>
              </Box>
            )}
            <Box component={"div"} gap={"12px"} className="d-flex align-items-center">
              <Box component={"div"} gap={"24px"} className="d-flex align-items-center">
                <IconButton
                  onClick={() => {
                    navigate.push(routes.calendar, {
                      breadCrumbItems: [pathname.split("/")[1], "Schedule"],
                    });
                  }}
                >
                  <IoCalendarClearOutline
                    style={{
                      height: "32px",
                      width: "32px",
                      color: "#333333",
                    }}
                  />
                </IconButton>
                {/* <IconButton
                  onClick={() => {
                    handleToggleDialog();
                  }}
                >
                  <IoNotificationsOutline
                    style={{
                      height: "32px",
                      width: "32px",
                      color: "#333333",
                    }}
                  />
                </IconButton> */}
                <IconButton
                  onClick={() => {
                    navigate.push(routes.facilitiesCart, {
                      breadCrumbItems: [pathname.split("/")[1], "Checkout"],
                    });
                  }}
                >
                  <Badge
                    badgeContent={cartCount}
                    color="primary"
                    sx={{
                      "& .MuiBadge-badge": {
                        background: "#  604797",
                      },
                    }}
                  >
                    <HiOutlineShoppingCart
                      style={{
                        height: "32px",
                        width: "32px",
                        color: "#333333",
                      }}
                    />
                  </Badge>
                </IconButton>
              </Box>
              <Box component={"div"} gap={"12px"} className="d-flex align-items-center">
                {role?.roleType === "guest" && !user?.name ? (
                  <img
                    src={guest}
                    alt="guest"
                    style={{
                      height: "30px",
                      width: "30px",
                      borderRadius: "50px",
                      objectFit: "contain",
                      margin: "auto 10px",
                    }}
                  />
                ) : (
                  <Box
                    component={"div"}
                    sx={{
                      height: "48px",
                      width: "48px",
                      borderRadius: "50px",
                      background: "#fff",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate.push(routes.myProfile, {
                        breadCrumbItems: [pathname.split("/")[1], "Profile details"],
                      });
                    }}
                  >
                    <Typography component={"h6"} variant="largemedium" color={"#604797"} textAlign={"center"}>
                      {getFirstLetters(user?.name || "")}
                    </Typography>
                  </Box>
                )}
                <Typography component={"h6"} variant="largemedium" color={"#333333"}>
                  {role?.roleType === "guest" && !user?.name ? "Guest" : user?.name}
                </Typography>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
      )}
    </>
  );
};

export default Header;
